import { AsyncScheduler } from './AsyncScheduler';

export class QueueScheduler extends AsyncScheduler {
}



// WEBPACK FOOTER //
// ./node_modules/rxjs/src/scheduler/QueueScheduler.ts